<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>
    <section class="aboutList cl">
      <div class="warp" v-for="(item, index) in AboutList" :key="index">
        <span class="year" v-if="item.year">{{ item.year }}</span>
        <div class="main cl">
          <div class="z gameBg">
            <!-- <a href="javascript:;"> -->
            <img :src="item.img" alt="" />
            <!-- </a> -->
          </div>
          <div class="cont z">
            <div class="date">{{ item.event_time }}</div>
            <div class="title ell2">
              {{ item.title }}
            </div>
            <div class="info"><pre v-html="item.detail"></pre></div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";
import { getAbout } from "@/common/api.js";
export default {
  name: "About",
  components: {
    Head,
    Foot,
    getAbout,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      AboutList: [],
      lang: this.$route.query.language || "zh",
    };
  },
  created() {
    this.getAbouts();
  },
  mounted() {},
  methods: {
    getAbouts() {
      let that = this;
      getAbout({
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.TopTitle = Data.TopTitle;
          that.TopContent = Data.TopContent;
          that.AboutList = Data.AboutList;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getAbouts();
      this.$refs.foot.langSelect(param);
    },
  },
  computed: {},
};
</script>

<style scoped>
.info pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>





















































// WEBPACK FOOTER //
// src/views/About.vue